/**
 * Portal services
 *
 * AngularJS API for the gis-portal-services project
 */
import View from "ol/View";
import {TileWMS} from "ol/source";
import {Coordinate} from "ol/coordinate";
import {IPointReport} from "../services/ISharedFeatureState";


export interface IPortalServices {
	dataPointQuery(
		coordinate: Coordinate,
		scienceLayerName : string | string[],
		httpConfig?: ng.IRequestShortcutConfig,
		includeGeometry?: boolean) : ng.IPromise<IPointReport|IRequestError>;

	geometryPointQuery(
		scienceLayerName: string,
		internalGeometryPk: number,
		httpConfig?: ng.IRequestShortcutConfig) : ng.IHttpPromise<any>;
	wmsGetFeatureInfo(coordinate: [number, number],
					  view: View,
					  source: TileWMS,
					  cache?: boolean,
					  info_format?: string) : ng.IHttpPromise<any>;
    baseUri(): string;
}

export interface IRequestError {
	error: any;
}

export class PortalServices implements IPortalServices {
	public static $inject = ['$http'];
	constructor(protected $http: ng.IHttpService) {

	}

    baseUri(): string {
        return '/services';
    }

	public dataPointQuery(coordinate: [number, number],
						  scienceLayerName : string | string[],
						  httpConfig: ng.IRequestShortcutConfig = {},
						  includeGeometry: boolean = false) : ng.IPromise<IPointReport|IRequestError> {

		const layers = Array.isArray(scienceLayerName) ? scienceLayerName.join(',') : scienceLayerName;

		httpConfig.params = {
			layers,
			latitude: coordinate[0],
			longitude: coordinate[1],
			epsg: 2193,
			include_geom: includeGeometry ? 'true': undefined
		};
		return this.$http.get(`${this.baseUri()}/point_query/json`,
			httpConfig).then((resp) => {
				return <IPointReport> resp.data;
			}, error => {
				return {error};
			});
	}

	public wmsGetFeatureInfo(coordinate: [number, number],
							 view: View,
							 source: TileWMS,
							 cache: boolean = false,
							 info_format: string = 'application/vnd.ogc.gml') : ng.IHttpPromise<any> {
		let resolution = view.getResolution();
		return this.$http.get(
			source.getFeatureInfoUrl(
					coordinate, resolution,
					"EPSG:2193", {	info_format }
				),
				{
					cache
				}
			);
	}

	public geometryPointQuery(scienceLayerName: string,
							  internalGeometryPk: number,
							  config: ng.IRequestShortcutConfig = {},
							  epsg: number = 2193) : ng.IHttpPromise<any> {
		config.params = {
			layer: scienceLayerName,
			id: internalGeometryPk,
			epsg
		};

		return this.$http.get(`${this.baseUri()}/point_query/geometry`, config)
	}
}
